import * as floatingInventory from './floatingInventory';
import * as floatingInventoryAudit from './floatingInventoryAudit';
import * as floatingInventoryReport from './floatingInventoryReport';
import * as dowloadAuditFloatingReportWait from './excel';

const reducers = {
  ...floatingInventory,
  ...floatingInventoryAudit,
  ...floatingInventoryReport,
  ...dowloadAuditFloatingReportWait,
};

export default reducers;
